export default {
  video: {
    title: 'Live Video',
    viewSwitch: 'View Switch: {view}',
  },
  views: {
    head: 'Head View',
    leftHand: 'Left Hand View',
    rightHand: 'Right Hand View',
  },
  info: {
    toggle: 'Robot Info',
  },
  robotInfo: {
    title: 'Robot Info',
    battery: 'Battery',
    batteryTemperature: 'Battery Temp',
    voltage: 'Voltage',
    position: 'Position',
    positionXY: 'X: {x}, Y: {y}',
    noValue: '--',
    noValuePercent: '--%',
    postureStanding: 'Standing',
    postureLying: 'Lying Down',
    postureUnknown: 'Unknown',
  },
  control: {
    moveSection: 'Movement',
    end: 'End',
    pause: 'Stop',
  },
  messages: {
    stopSuccess: 'Task stopped successfully',
    endTaskSuccess: 'Task ended successfully',
    stopFailed: 'Failed to stop inspection task',
    noActiveTask: 'No task in progress',
    pauseSuccess: 'Paused successfully',
    pauseFailed: 'Failed to pause task',
    streamNotConfigured: 'Stream URL is not configured for this view',
  },
}
